export default {
  PIZZA_TABS: {
    CRUST: 1,
    SAUCE: 2,
    CHEESE: 3,
    TOPPINGS: 4
  }
}
